import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss']
})
export class PillComponent implements OnInit {
  @Input() value: string;
  @Input() selected: boolean;
  @Input() editable: boolean = true;
  @Output() selectedChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  togglePill() {
    if (this.editable) {
      // this.selected = !this.selected;
      this.selectedChange.emit(!this.selected);
    }
  }

}
